import React, { useState } from 'react';
import { Shield, Mail, Lock, AlertCircle, ArrowRight } from 'lucide-react';

export default function LoginScreen({ fazerLogin, carregandoLogin, erroLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  const submitLogin = (e) => {
    e.preventDefault();
    fazerLogin(email, senha);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-surface-muted via-surface to-brand-50 p-6">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-brand-600 text-white flex items-center justify-center shadow-pop mb-3">
            <Shield size={26} strokeWidth={2.25} />
          </div>
          <h1 className="text-xl font-semibold text-ink tracking-tight">Defend Proteção Veicular</h1>
          <p className="text-sm text-ink-subtle mt-1">Mesa de Atendimento</p>
        </div>

        <div className="card p-7">
          <div className="mb-5">
            <h2 className="text-base font-semibold text-ink">Acesse sua conta</h2>
            <p className="text-xs text-ink-subtle mt-1">
              Use suas credenciais corporativas para entrar.
            </p>
          </div>

          {erroLogin && (
            <div className="mb-4 flex items-start gap-2 rounded-xl bg-danger-50 text-danger-700 px-3.5 py-2.5 text-sm">
              <AlertCircle size={16} className="mt-0.5 shrink-0" />
              <span>{erroLogin}</span>
            </div>
          )}

          <form onSubmit={submitLogin} className="flex flex-col gap-3">
            <div>
              <label className="label" htmlFor="email">E-mail</label>
              <div className="relative">
                <Mail
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-faint pointer-events-none"
                />
                <input
                  id="email"
                  type="email"
                  placeholder="seu.email@defendprotecao.com.br"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input pl-9"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <div>
              <label className="label" htmlFor="senha">Senha</label>
              <div className="relative">
                <Lock
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-faint pointer-events-none"
                />
                <input
                  id="senha"
                  type="password"
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  className="input pl-9"
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn-primary mt-2"
              disabled={carregandoLogin}
            >
              {carregandoLogin ? 'Entrando…' : (
                <>
                  Entrar <ArrowRight size={16} />
                </>
              )}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-ink-faint mt-6">
          © {new Date().getFullYear()} Defend Proteção Veicular
        </p>
      </div>
    </div>
  );
}
